module.exports = __webpack_public_path__ + "img/11.35591fa6.jpg";